<img [src]="imageUrl" [alt]="reaction" [width]="size" [height]="size" />
